import styled from '@emotion/styled';
import { PageShell } from 'views/CalendarReminderPage/CalendarReminderPage.styled';

export const Backdrop = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 11;
`;

export const ModalShell = styled(PageShell)`
    width: min(520px, calc(100vw - 32px));
    max-width: 520px;
`;
